import { Component, OnInit, Input } from '@angular/core';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { faEye, faAddressCard, faTimesCircle, faCheckCircle } from '@fortawesome/free-regular-svg-icons';

import { Patient } from '../patient';

@Component({
  selector: 'mc-patient-card',
  templateUrl: './patient-card.component.html',
  styleUrls: ['./patient-card.component.scss']
})
export class PatientCardComponent implements OnInit {

  pencilAlt = faPencilAlt;
  eyeIcon = faEye;
  addressCard = faAddressCard;
  timesCircle = faTimesCircle;
  checkCircle = faCheckCircle;

  editing: boolean = false;

  @Input() patients: Patient[];

  constructor() { }

  ngOnInit() {
  }

  startEditing(): void {
    this.editing = true;
  }
}
